module.exports = __webpack_public_path__ + "static/img/wl_xxsz.acc8b83.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/busSupport/wl_xxsz.png
// module id = 6/lx
// module chunks = 1